


































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyList from "@/mixins/list";

import SmsAdd from "@/views/sms/add.vue";
import PushAdd from "@/views/message/Add.vue";

import AdserverAdd from "@/views/adserver/banners/add.vue";
import AnnouncementAdd from "@/views/announcement/add.vue";

@Component({
  components: {
    SmsAdd,
    PushAdd,
    AdserverAdd,
    AnnouncementAdd
  }
})
export default class extends Mixins(MyList) {
  @Prop() operationName!: string;

  smsAddVisible: boolean = false;
  pushAddVisible: boolean = false;
  adserverAddVisible: boolean = false;
  announcementAddVisible: boolean = false;

  dispatchType: string = "syslog/manager";

  selectedRowKeys: any[] = [];
  selectedRows: any[] = [];

  smsRules: any[] = [];
  pushRules: any[] = [];
  adserverRules: any[] = [];
  announcementRules: any[] = [];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "馆长用户名称", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "场馆名称", dataIndex: "name" }
  ];

  showSmsAddModal() {
    this.smsRules = [];
    const mobiles: string[] = [];
    for (const obj of this.selectedRows) {
      mobiles.push(obj.mobile);
    }
    this.smsRules.push({
      rule_relation: "and",
      rule_name: "mobile",
      rule_operator: "contain",
      rule_value: mobiles.join(","),
      rule_sort: 1
    });
    this.smsAddVisible = true;
  }

  hideSmsAddModal() {
    this.smsAddVisible = false;
  }

  showPushAddModal() {
    this.pushRules = [];
    const userIds: string[] = [];
    for (const obj of this.selectedRows) {
      userIds.push(obj.user_id);
    }
    this.pushRules.push({
      rule_relation: "and",
      rule_name: "user_id",
      rule_operator: "contain",
      rule_value: userIds,
      rule_sort: 1
    });
    this.pushAddVisible = true;
  }

  hidePushAddModal() {
    this.pushAddVisible = false;
  }

  showAdserverAddModal() {
    this.adserverRules = [];
    const userIds: string[] = [];
    for (const obj of this.selectedRows) {
      userIds.push(obj.user_id);
    }
    this.adserverRules.push({
      rule_relation: "and",
      rule_name: "user_id",
      rule_operator: "contain",
      rule_value: userIds,
      rule_sort: 1
    });
    this.adserverAddVisible = true;
  }

  hideAdserverAddModal() {
    this.announcementAddVisible = false;
  }

  showAnnouncementAddModal() {
    this.announcementRules = [];
    const userIds: string[] = [];
    for (const obj of this.selectedRows) {
      userIds.push(obj.user_id);
    }
    this.announcementRules.push({
      rule_relation: "and",
      rule_name: "user_id",
      rule_operator: "contain",
      rule_value: userIds,
      rule_sort: 1
    });
    this.announcementAddVisible = true;
  }

  hideAnnouncementAddModal() {
    this.announcementAddVisible = false;
  }

  onSelectChange(selectedRowKeys: any, selectedRows: any) {
    this.selectedRows = _.uniq(_.concat(this.selectedRows, selectedRows));
    this.selectedRowKeys = selectedRowKeys;
  }

  mounted() {
    this.loadData(
      {
        operation_name: this.operationName
      },
      false
    );
  }
}
